import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentItrackStatusTypeAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetItrackStatusType`,
    method: 'get',
  });
};

export type ShipmentItrackStatusTypeResponse = {
  codeId: string;
  codeDesc: string;
  lookUpCodeType: string;
  lookupKey: number;
}[];

export const fetchShipmentItrackStatusType = async (): Promise<ShipmentItrackStatusTypeResponse> => {
  const response: AxiosResponse<ShipmentItrackStatusTypeResponse> = await getShipmentItrackStatusTypeAPI();
  return response.data;
};
